const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://sunshine-tours.onrender.com').replace(/\/+$/, '');

export function apiUrl(path = '') {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export { API_BASE_URL };
